'use strict';

var StrategyListingDirective = function StrategyListingDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/strategy-listing.html'),
    controller: 'StrategyListingController',
    scope: {
      activeStrategyType: '=',
      panelsManager: '=',
      showHideHandler: '='
    }
  };
};
StrategyListingDirective.$inject = [];
module.exports = StrategyListingDirective;